<template>
  <div class="progress-container">
    <div class="title text-blue">You're {{ value }}% done</div>
    <progress max="100" :value="value"></progress>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    value: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-container {
  max-width: 600px;
  margin: 0 auto 4rem;
}

.title {
  font-weight: bold;
  font-size: 0.9em;
}

progress {
  width: 100%;
  appearance: none;
  height: 6px;
}

progress[value]::-webkit-progress-bar {
  background-color: #C8C8C8;
  border-radius: 3px;
}
progress[value]::-webkit-progress-value {
  background-color: #0061aa;
  border-radius: 3px;
}
</style>
